import React from 'react';

import { ScreenLink, useScreenState } from '@gogame/screens';
import { hourlyTrackerLink } from 'scenes/Trackers/HourlyTracker/navigation';
import {
  DRILL_DOWN,
  hourlyTrackerReducer,
} from 'scenes/Trackers/HourlyTracker/reducers';
import { DateValueFormatter } from '@gogame/intl-ts';

const Hour = ({ id, value, nextLevel }) => {
  const screenState = useScreenState();

  const canDrillDown = !!nextLevel;

  const content = (
    <DateValueFormatter
      value={value}
      timeZone={'utc'}
      template={'HH:mm'}
      dashed={false}
    />
  );
  return canDrillDown ? (
    <ScreenLink
      link={hourlyTrackerLink}
      searchParams={hourlyTrackerReducer(screenState, {
        type: DRILL_DOWN,
        payload: {
          id: id,
          nextLevel: nextLevel,
        },
      })}
    >
      {content}
    </ScreenLink>
  ) : (
    content
  );
};

export default Hour;
